import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { isEmpty } from 'lodash';
import IntlMessages from 'util/IntlMessages';

const currencies = [
  {
    Value: 2,
    Label: <IntlMessages id="Errand.Economy.Invoice.option2"/>
  },
  {
    Value: 3,
    Label: <IntlMessages id="Errand.Economy.Invoice.option3"/>
  },
  {
    Value: 4,
    Label: <IntlMessages id="Errand.Economy.Invoice.option4"/>
  },
  {
    Value: 5,
    Label: <IntlMessages id="Errand.Economy.Invoice.option5"/>
  },
];
class AvtalsTyp extends Component {
    state={
        ArendeStatus:0
    }
    getAvtalType=(e)=>{
        let Meta = "ArendeFaktura"
        this.props.onChangeHandleMulti(Meta,e.target.value)        
    }
    render() {
        return (
            <div>
                <form>
                <div style={{ height: 'auto', paddingTop: '10px' }}>
                <TextField
                    select
                    Label={<IntlMessages id="Errand.Economy.Invoice" />}
                    variant="outlined"
                    size="small"
                    value={this.state.ArendeStatus}
                    fullWidth
                    onChange={this.getAvtalType}
                    SelectProps={{
                        native: true,
                    }}
                >
                    <option Key="0" disabled  value={0}><IntlMessages id="Choose"/></option>
                    {currencies.map((option) => (
                        <option key={option.Value} value={option.Value}>
                            {option.Label}
                        </option>
                    ))}
                </TextField>
            </div>
        </form>
            </div>
        );
    }
}

export default (AvtalsTyp);
